import React, { useEffect } from "react";
import { getTawkEmbedSrc } from "../utils/tawkLiveChat";

declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>;
    Tawk_LoadStart?: Date;
  }
}

const TawkLiveChat: React.FC = () => {
  useEffect(() => {
    const embedSrc = getTawkEmbedSrc();
    if (!embedSrc || window.Tawk_LoadStart) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const script = document.createElement("script");
    script.async = true;
    script.src = embedSrc;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.body.appendChild(script);
    }
  }, []);

  return null;
};

export default TawkLiveChat;
